import { render } from "./student-gallery.vue?vue&type=template&id=2b32b31f&scoped=true&ts=true"
import script from "./student-gallery.ts?vue&type=script&lang=ts&external"
export * from "./student-gallery.ts?vue&type=script&lang=ts&external"

import "./student-gallery.vue?vue&type=style&index=0&id=2b32b31f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b32b31f"]])

export default __exports__